import React, { useEffect, useState } from "react";
// import MultipleMarker from "../../../../../components/Map/MultipleMarkerMap";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../../store/app";
import { fetchVrTraining } from "../Utils/slice";
import PageSpinner from "../../../../../components/PageSpinner/PageSpinner";
import BreadcrumbComponent from "../../../CommonComponent/BreadcrumbComponent";
import {
  LocationsBreadcrumb,
  TrainingLocationBreadcrumb,
} from "../../../../../config/BreadcrumbConfig";
import greenImg from "../../../../../assets/webimage/Green-Location-icon.png";
import blueImg from "../../../../../assets/webimage/Blue-Location-icon.png";
import redlocation from "../../../../../assets/images/location-icon-red.png";
import { setUserOptions } from "../../../../../store/AuthSlice";
import { get_users_industry } from "../../../../../config/Global";
import { Col, Row } from "antd";
// import redImg from "../../../../../assets/webimage/Red-Location-icon.png"

/**
 * Renders the VR Training Location component.
 *
 * @return {JSX.Element} The rendered VR Training Location component.
 */
const VRTrainingLocation = () => {
  const dispatch: AppDispatch = useDispatch();
  const { mapScriptLoaded } = useSelector((state: RootState) => state.AUTH);
  const vrData = useSelector((state: RootState) => state.WEBPROFILE.vrTraining);
  const userDetail = useSelector((state: RootState) => state.AUTH.userDetail);
  const [loading, setLoading] = useState(true);
  // const marker_icon = redImg
  const marker_icon = blueImg;
  const green = greenImg;
  const { is_solar } = get_users_industry(userDetail);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    dispatch(setUserOptions())
      .then()
      .catch((e: any) => e);
    dispatch(fetchVrTraining())
      .then(() => {
        setLoading(false);
      })
      .catch((error: any) => error);
  }, [mapScriptLoaded]);

  return (
    <div style={{ background: "#f5f6f7" }} className="all-careers-mobile">
      <section>
        <div className="container-fluid">
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <div className="career-index-header mobile-header">
                <BreadcrumbComponent
                  key={1}
                  items={TrainingLocationBreadcrumb.path}
                />
                <div
                  style={{
                    fontSize: 17,
                    color: "#555",
                    marginLeft: 5,
                    marginTop: 10,
                  }}
                >
                  Build your foundation with IWNL Energy across Awareness, 101, and 102, then choose nearby colleges, labor unions, and partner sites on the map to continue your career journey.
                </div>
              </div>
            </Col>
            <Col span={24}>
              <div
                style={{
                  borderRadius: 16,
                  border: "1px solid #e5e7eb",
                  overflow: "hidden",
                  background: "#fff",
                  boxSizing: "border-box",
                }}
              >
                {userDetail?.industry_id == 1 ? (
                  <iframe
                    className="map-container__map"
                    src="https://www.google.com/maps/d/embed?mid=1wvofPbRLkd2oueDaBjtj3lxBUjZzHRkd&ehbc=2E312F&z=3"
                    style={{ width: "100%", minHeight: 400, border: "none" }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Training Locations Map"
                  ></iframe>
                ) : (
                  <iframe loading="lazy" className="map-container__map" style={{ width: "100%", minHeight: 400, border: "none" }} allow="local-network-access; geolocation" title="Education and Training Database" src="https://www.arcgis.com/apps/mapviewer/index.html?configurableview=true&webmap=1c69fb70ab4b4c0cb95ffa5a8cc3282c&theme=light&legend=true&information=true&center=-94.31789185597125,41.49815211788374&scale=36978595.474472" ></iframe>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default VRTrainingLocation;
